import { VotingConstants } from "../../constants/voting.constants";

export const controlModal = (opened, showEntity, showContent) => {
	return {
		type: VotingConstants.CONTROL_MODAL,
		payload: {
			opened,
			showContent,
			showEntity,
		},
	};
};
